import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { pathForMilestone, PrototypePath } from 'prototypes/securedCard/paths';
import { milestoneRank } from 'prototypes/securedCard/storyMath';
import DashboardStep from 'prototypes/securedCard/screens/DashboardStep';
import GrowthStep from 'prototypes/securedCard/screens/GrowthStep';
import KeepStep from 'prototypes/securedCard/screens/KeepStep';
import PaycheckStep from 'prototypes/securedCard/screens/PaycheckStep';
import SellPage from 'prototypes/securedCard/screens/SellPage';
import SpendStep from 'prototypes/securedCard/screens/SpendStep';
import TransactionsStep from 'prototypes/securedCard/screens/TransactionsStep';
import { StoryProvider, useStory } from 'prototypes/securedCard/StoryContext';
import { StoryMilestone } from 'prototypes/securedCard/types';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const StepGate = ({ minimum, children }: { minimum: StoryMilestone; children: React.ReactElement }) => {
  const { state } = useStory();
  if (milestoneRank(state.milestone) < milestoneRank(minimum)) {
    return <Navigate to={pathForMilestone(state.milestone)} replace />;
  }
  return children;
};

const PrototypeRoutes = () => (
  <>
    <ScrollToTop />
    <Routes>
      <Route path={PrototypePath.Landing} element={<SellPage />} />
      <Route path={PrototypePath.Welcome} element={<SellPage />} />
      <Route
        path={PrototypePath.Paycheck}
        element={
          <StepGate minimum={StoryMilestone.Started}>
            <PaycheckStep />
          </StepGate>
        }
      />
      <Route
        path={PrototypePath.Growth}
        element={
          <StepGate minimum={StoryMilestone.PaycheckSet}>
            <GrowthStep />
          </StepGate>
        }
      />
      <Route
        path={PrototypePath.Spend}
        element={
          <StepGate minimum={StoryMilestone.GrowthSeen}>
            <SpendStep />
          </StepGate>
        }
      />
      <Route
        path={PrototypePath.Keep}
        element={
          <StepGate minimum={StoryMilestone.PurchasePaid}>
            <KeepStep />
          </StepGate>
        }
      />
      <Route
        path={PrototypePath.Dashboard}
        element={
          <StepGate minimum={StoryMilestone.Complete}>
            <DashboardStep />
          </StepGate>
        }
      />
      <Route
        path={PrototypePath.Transactions}
        element={
          <StepGate minimum={StoryMilestone.PaycheckSet}>
            <TransactionsStep />
          </StepGate>
        }
      />
      <Route path="*" element={<Navigate to={PrototypePath.Welcome} replace />} />
    </Routes>
  </>
);

const SecuredCardPrototype = () => {
  useEffect(() => {
    document.title = 'Plannery secured card prototype';
  }, []);

  return (
    <StoryProvider>
      <PrototypeRoutes />
    </StoryProvider>
  );
};

export default SecuredCardPrototype;
